import React, { useContext, useEffect, useMemo, useRef } from "react";

import PropTypes from "prop-types";
import { ToastContext } from "../../../Context/ToastContext";

const alertType = {
  error: { variant: "danger", icon: "ri-alert-line", title: "Error" },
  success: {
    variant: "success",
    icon: "ri-checkbox-circle-line",
    title: "Success",
  },
  warning: { variant: "warning", icon: "ri-alert-line", title: "Warning!" },
  info: { variant: "danger", icon: "ri-information-line", title: "Info" },
  danger: { variant: "danger", icon: "ri-alert-line", title: "Error" },
};

const XAlertMessage = ({
  type,
  message,
  alertShow,
  setAlertShow,
  timeToWait = 10000,
  maxWidth = "600px", // legacy prop, intentionally retained for compatibility
}) => {
  void maxWidth;
  const { addToast } = useContext(ToastContext);
  const lastToastKeyRef = useRef("");
  const wasVisibleRef = useRef(false);

  const config = type && alertType[type] ? alertType[type] : alertType.error;
  const normalizedMessage = useMemo(
    () => (message === null || typeof message === "undefined" ? "" : String(message)),
    [message],
  );
  const shouldRender = Boolean(config && normalizedMessage);
  const persistentThreshold = 99999999;

  useEffect(() => {
    if (!alertShow || !shouldRender) {
      wasVisibleRef.current = false;
      return;
    }

    const isFreshOpen = !wasVisibleRef.current;
    wasVisibleRef.current = true;

    if (!isFreshOpen) return;

    const toastKey = `${config.variant}::${config.title}::${normalizedMessage}`;
    if (lastToastKeyRef.current === toastKey) {
      setAlertShow(false);
      return;
    }

    lastToastKeyRef.current = toastKey;

    const duration = Number(timeToWait) > 0 ? Number(timeToWait) : 5000;
    const persistent = duration >= persistentThreshold;

    addToast(
      {
        title: config.title,
        message: normalizedMessage,
      },
      config.variant,
      duration,
      {
        persistent,
        html: true,
      },
    );
    setAlertShow(false);
  }, [addToast, alertShow, config.title, config.variant, normalizedMessage, setAlertShow, shouldRender, timeToWait]);

  return null;
};

XAlertMessage.propTypes = {
  type: PropTypes.string,
  message: PropTypes.any,
  alertShow: PropTypes.bool,
  setAlertShow: PropTypes.func,
};

export default XAlertMessage;
